import {
    BASKET_ANALYSIS_SUCCESS,
    BASKET_ANALYSIS_LOADING

} from '../actions/BasketAnalysisAction';

const initialState = {
    amazon: {
        basketAnalysisData: null,
        isLoading: true,
    },
    shopify: {
        basketAnalysisData: null,
        isLoading: true,
    },
    wholesale: {
        basketAnalysisData: null,
        isLoading: true,
    },
};

const BasketAnalysisReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case BASKET_ANALYSIS_SUCCESS:
            return {
                ...state, [action?.vendor]: { basketAnalysisData: action.data, isLoading: false }
            };

            case BASKET_ANALYSIS_LOADING:
            return { ...state, [action?.vendor]: { ...state?.[action?.vendor], isLoading: action.isLoading } };

            default:
            return state;
    }
};

export default BasketAnalysisReducer;
